// extracted by mini-css-extract-plugin
export default {"mapLocation":"styles_mapLocation__T2GWp"};